import React from 'react'
import Card from '@components/V3/Card'
import SectionSkeleton from '@page-components/CheckoutV3/components/SectionSkeleton'

import SummarySkeleton from './SummarySkeleton'

export default function PaymentSkeleton() {
  return (
    <Card transparentOnDesktop>
      {/* Tip */}
      <div className="flex flex-col animate-pulse space-y-2 px-4">
        <div className="py-2">
          <div className="w-12 h-3 bg-gray-200 dark:bg-zinc-600 rounded"></div>
        </div>
        <div className="flex space-x-2 justify-center overflow-x-clip">
          <div className="w-full h-[48px] bg-gray-200 dark:bg-zinc-600 rounded"></div>
          <div className="w-full h-[48px] bg-gray-200 dark:bg-zinc-600 rounded"></div>
          <div className="w-full h-[48px] bg-gray-200 dark:bg-zinc-600 rounded"></div>
          <div className="w-full h-[48px] bg-gray-200 dark:bg-zinc-600 rounded"></div>
        </div>
      </div>
      {/* Summary */}
      <SummarySkeleton />
      {/* Payment Method */}
      <div className="flex flex-col animate-pulse space-y-1 py-2 mt-4 mb-2 px-4">
        <div className="w-12 h-3 bg-gray-200 dark:bg-zinc-600 rounded"></div>
        <div className="">
          <SectionSkeleton
            transparentOnDesktop
            icon={<div className="w-6 h-6 bg-gray-200 dark:bg-zinc-600 rounded" />}
          />
        </div>
      </div>
      {/* Payment Button */}
      <div className="flex flex-col animate-pulse ">
        <div className="p-4">
          <div className="w-full h-14 bg-gray-200 dark:bg-zinc-600 rounded"></div>
        </div>
      </div>
    </Card>
  )
}
